<template>
    <div>
        <PageTitle :title="$t('simpatizantes.titulo', { simpatizantes: configuracion.simpatizantes, temporada: lista_abonados.nombre })" sectionClass="strech"/>
        <section class="padding-vertical-content pb-0 right-background">
            <div class="thumb-container absolute grayscale light-thumb" :style='"background-image: url(" + footer.bg1_url + ");"'></div>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row justify-content-start">
                            <div class="col-12 col-lg-6">
                                <div class="subtitle h3 light mb-3">{{ $t('simpatizantes.tu_abono', { simpatizantes: configuracion.simpatizante }) }}</div>
                                <div class="thecontent mb-3" v-html="configuracion.descripcion_simpatizante"></div>
                            </div>
                            <div class="col-12 col-lg-2">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="form" class="padding-vertical-content lightgray-content">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="m-0 h1 text-uppercase">{{ $t('simpatizantes.completa_datos') }}</h2>
                        <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('simpatizantes.completa_info', { simpatizantes: configuracion.simpatizante, abono: teatro.texto_abono }) }}</div>
                        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                            <fieldset :disabled="formBloqueado" style="border: none; padding: 0; margin: 0;">
                                <div class="row">
                                    <div class="col-12 col-lg-4">
                                        <FormInput :label="$t('formularios.nombre')" id="nommbre" name="nombre" rules="required" v-model="simpatizante.nombre" />
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <FormInput :label="$t('formularios.apellidos')" id="apellidos" name="apellidos" rules="required" v-model="simpatizante.apellidos" />
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <DocumentoTipo
                                            v-model="simpatizante.tipoDocumento"
                                            :index="0"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-lg-4">
                                        <DocumentoValor
                                            v-model="simpatizante.dni"
                                            :type="simpatizante.tipoDocumento"
                                            :index="0"
                                        />
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <div class="form-group">
                                            <label for="fecha_nacimiento">{{ $t('formularios.nacimiento') }}</label>
                                            <ValidationProvider name="fecha de nacimiento" rules="required" v-slot="{ errors }">
                                                <datetime
                                                    v-model="simpatizante.fecha_nacimiento"
                                                    :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                                    type="date"
                                                    input-id="fecha_nacimiento"
                                                    min-datetime="1900-01-01"
                                                />
                                                <span v-if="errors[0]" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;margin-top: 0.3rem;">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </div>
    
                                    <div class="col-12 col-lg-4">
                                        <FormInput :label="$t('formularios.email')" id="email" name="email" rules="required" v-model="simpatizante.email" />
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <FormInput :label="$t('formularios.telefono')" id="telefono" name="telefono" rules="required" v-model="simpatizante.telefono" />
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <FormInput :label="$t('formularios.provincia')" id="provincia" name="provincia" rules="required" v-model="simpatizante.provincia" />
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <FormInput :label="$t('formularios.localidad')" id="localidad" name="localidad" rules="required" v-model="simpatizante.localidad" />
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <FormInput :label="$t('formularios.domicilio')" id="domicilio" name="domicilio" rules="required" v-model="simpatizante.domicilio" />
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <FormInput :label="$t('formularios.cp')" id="cp" name="código postal" rules="required" v-model="simpatizante.codigo_postal" />
                                    </div>
                                    <div class="col-12 col-md-12 col-lg-12" v-if="mostrar_tipo_abonos">
                                        <div class="form-group">
                                            <label for="descuento">{{ $t('formularios.tipo_abono', {abono: teatro.texto_abono}) }}</label>
                                            <ValidationProvider name="descuento" rules="required" v-slot="{ errors }">
                                                <multiselect
                                                    :class="(errors[0] ? 'is-invalid' : '')"
                                                    v-model="simpatizante.tipo_abono"
                                                    :placeholder="$t('formularios.tipo_abono', {abono: teatro.texto_abono})"
                                                    label="descripcion"
                                                    track-by="id"
                                                    :options="zona.tipos_abonos"
                                                />
                                                <small v-if="errors[0]" class="text-danger">{{ $t('formularios.tipo_abono', {abono: teatro.texto_abono}) }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-8 p-0 mb-2 mt-2">
                                    <FormTerminos
                                        :error="error"
                                        @continuar="aceptarCondiciones"
                                    />
                                </div>
                            </fieldset>

                            <div class="form-group">
                                <span>
                                    <b v-if="configuracion.hash_teatro == 'J1fKG9AarPuPNJ5hwY0t'">
                                        {{ $t('simpatizantes.aviso_abono_simpatizante', { texto_simpatizante: teatro.texto_simpatizante }) }}
                                        <b><a href="https://www.realmurcia.es/abono-centenario-imperial/" target="_blank">aquí</a></b>
                                    </b>
                                    <b v-else-if="configuracion.hash_teatro == 'KbG3Jc0gLsXpVHncS9P6'">
                                        {{ $t('simpatizantes.aviso_abono', {abono: teatro.texto_abono}) }}
                                    </b>
                                    <template v-else>
                                        <b v-if="configuracion.hash_teatro == 'hvLux5tvnE5HMsDiXOt2'">{{ $t('simpatizantes.acceso_tercera_femenino', {abono: teatro.texto_abono}) }}</b>
                                        <b v-else-if="configuracion.hash_teatro == 'BHlBbABzmZ5qkeNOHcGH'">{{ $t('simpatizantes.4_entradas', {abono: teatro.texto_abono}) }}</b>
                                        <b v-else>{{ textoSimpatizante }}</b>
                                    </template>
                                </span>
                            </div>

                            <Button
                                type="submit"
                                :label="$t('simpatizantes.continuar')"
                                :disabled="formBloqueado"
                            />
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </section>

        <transition name="fade" mode="out-in">
            <section v-if="resumen" class="padding-vertical-content" key="resumen" id="resumen">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('simpatizantes.resumen_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-4 mb-lg-5">{{ $t('simpatizantes.comprueba_info') }}</div>
                            <div class="row justify-content-start">
                                <div class="col-12 col-lg-5">
                                    <ul class="resumen d-block">
                                        <li class="w-100">
                                            <label>{{ $t('simpatizantes.nombre_completo') }}</label>
                                            <div>{{ simpatizante.nombre }} {{ simpatizante.apellidos }}</div>
                                        </li>
                                        <li class="w-100">
                                            <label>{{ $t('formularios.dni') }}</label>
                                            <div>{{ simpatizante.dni }}</div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <label>{{ $t('simpatizantes.tipo_abono', {abono: teatro.texto_abono}) }}</label>
                                    <div class="h2 mt-0 mb-3 gradient-color">{{ simpatizante.tipo_abono.descripcion }}</div>
                                    <label>{{ $t('simpatizantes.precio_abono', {abono: teatro.texto_abono}) }}</label>
                                    <div class="price price-large gradient-color">{{ precio_total | formatear_precio }}</div>
                                    <p class="mb-2 mb-md-4">
                                        <small v-if="!price_management_interno">
                                            * {{ $t('general.el_precio', { precio: $options.filters.formatear_precio(precio), gastos: $options.filters.formatear_precio(price_management), iva: 21, moneda: '€' }) }}
                                        </small>
                                    </p>
                                    <div class="mt-4 mt-lg-4">
                                        <Button
                                            type="button"
                                            :label="$t('formularios.atras')"
                                            @click="volverAlForm"
                                            custom-class="mr-2"
                                        />
                                        <Button
                                            id="terminar-compra"
                                            type="button"
                                            :label="$t('simpatizantes.continuar')"
                                            @click="terminar"
                                        />
                                    </div>
                                    <template v-if="formulario != null">
                                        <div id="formulario-compra" v-html="formulario" v-show="false">
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section v-if="typeof error == 'string'" class="padding-vertical-content" key="resumen" id="resumen">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ error }}</h2>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <transition name="fade" mode="out-in">
            <section v-if="procesar_pago" class="padding-vertical-content lightgray-content mb-3 mb-lg-4" key="pago" id="pago">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                            <PagoPaycometComponent ref="pago" tipo_venta="simpatizante" :jet_id="jet_id" :session_id="session_id" />
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>


<script setup>
    import { ref, computed, onBeforeUnmount, nextTick, getCurrentInstance } from 'vue';
    import store from '@/store';
    import { config } from '@/config.js';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import PagoPaycometComponent from "@/components/frontend/compra/components/PagoPaycometComponent";
    import DocumentoTipo from '@/components/common/DocumentoTipo.vue';
    import DocumentoValor from '@/components/common/DocumentoValor.vue';
    import Button from '@/modules/ui/Button.vue';

    const observer = ref(null);
    const pago = ref(null);
    const { proxy } = getCurrentInstance();

    const form = ref(false);
    const resumen = ref(false);
    const formulario = ref(null);
    const terminos = ref(null);
    const terminos_error = ref(false);
    const precio = ref(null);
    const error = ref(false);
    const zona = ref(null);
    const mostrar_tipo_abonos = ref(false);
    const price_management = ref(null);
    const price_management_interno = ref(null);
    const precio_total = ref(null);
    const session_id = ref(null);
    const jet_id = ref(null);
    const procesar_pago = ref(false);
    const privacidad = ref(false);
    const condiciones = ref(false);
    const comunicaciones = ref(false);
    const loading = ref(false);

    const simpatizante = ref({
        tipoDocumento: 'DNI',
    });

    const lista_abonados = computed(() => store.getters.getListaAbonados);
    const configuracion = computed(() => store.getters.getConfig);
    const footer = computed(() => store.getters.getFooter);
    const teatro = computed(() => store.getters.getTeatro);
    const formBloqueado = computed(() => resumen.value);

    const scrollTo = paso => {
        proxy.$scrollTo(paso, 300, { easing: 'ease-in-out' });
    };

    const verForm = () => {
        form.value = true;
        nextTick(() => {
            scrollTo('#form');
        });
    };

    const volverAlForm = () => {
        resumen.value = false;
        nextTick(() => {
            scrollTo('#form');
        });
    };

    const submit = async() => {
        const isValid = await observer.value.validate();

        if (!terminos.value) {
            error.value = true;
        }

        if (isValid && terminos.value) {
            guardarDatos();
        } else {
            terminos_error.value = true;
        }
    };

    const guardarDatos = () => {
        loading.value = true;

        simpatizante.value.area = {
            condiciones: condiciones.value,
            privacidad: privacidad.value,
            comunicaciones: comunicaciones.value
        };

        const params = {
            filters: {
                tid: configuracion.value.hash_teatro
            },
            datos_comprador: simpatizante.value,
        };

        store.dispatch(config.getVuexAlias('front.guardar.datos.comprador.internacional'), params)
            .then(res => {
                formulario.value = res.data.formulario;
                jet_id.value = res.data.jet_id;
                session_id.value = res.data.session_id;
                precio.value = res.data.precio;
                precio_total.value = res.data.precio_total;
                price_management.value = res.data.gd;
                price_management_interno.value = res.data.interno;
                loading.value = false;
                resumen.value = true;
                error.value = false;

                nextTick(() => {
                    scrollTo('#resumen');
                });
            })
            .catch(err => {
                resumen.value = false;
                error.value = 'No hay ninguna tarifa disponible';
                console.error(err);
                loading.value = false;
            });
    };

    const terminar = () => {
        if (terminos.value) {
            if (formulario.value) {
                setTimeout(() => {
                    const form = document.querySelector('#formulario-compra form');
                    if (form) form.submit();
                }, 1000);
            } else {
                procesar_pago.value = true;
                nextTick(() => {
                    scrollTo('#pago');
                });
            }
        } else {
            error.value = true;
        }
    };

    const getZona = () => {
        const params = {
            filters: {
                tid: configuracion.value.hash_teatro,
                zona_id: 'Internacional'
            },
            tid: configuracion.value.hash_teatro,
            zona_id: 'Internacional'
        };

        store.dispatch(config.getVuexAlias('front.zonas.show'), params)
            .then(res => {
                zona.value = res.data.data;

                if (zona.value.tipos_abonos.length > 1) {
                    mostrar_tipo_abonos.value = true;
                } else {
                    mostrar_tipo_abonos.value = false;
                    simpatizante.value.tipo_abono = zona.value.tipos_abonos[0];
                }
            })
            .catch(err => {
                console.error('Error al obtener zona:', err);
            });
    };

    const aceptarCondiciones = (continuar, priv, cond, comun) => {
        terminos.value = continuar;
        privacidad.value = priv;
        condiciones.value = cond;
        comunicaciones.value = comun;
    };

    getZona();

    onBeforeUnmount(() => {
        if (procesar_pago.value && pago.value) {
            pago.value.clearAllIntervals();
        }
    });
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
